import type { Ref } from "react";

/** Point a ref passed by a caller (a callback or an object) at a node. */
export function assignRef<T>(ref: Ref<T> | undefined, node: T | null): void {
  if (typeof ref === "function") ref(node);
  else if (ref) ref.current = node;
}
